import React from "react";
import Grid from "@mui/material/Grid";
import style from "./style";
import Button from "@mui/material/Button";
import { Avatar, Box, Typography } from "@mui/material";
import {ReactComponent as Download} from "../../../../assets/ViewLeave-images/download.svg";
import {ReactComponent as Print} from "../../../../assets/ViewLeave-images/print.svg";
import {ReactComponent as Send} from "../../../../assets/ViewLeave-images/send.svg";
import Profile from "../../../../assets/ViewLeave-images/salaryProfile.svg";


const PayrollSalaryPage = () => {

  const handleDownloadPDF = () => {
    // Generate or fetch PDF content
    const pdfContent = "Your PDF content goes here";
    
    // Create a blob from the PDF content
    const blob = new Blob([pdfContent], { type: "application/pdf" });

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor element
    const a = document.createElement("a");
    a.href = url;
    a.download = "example.pdf";

    // Append the anchor to the body and click it programmatically
    document.body.appendChild(a);
    a.click();

    // Cleanup
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };


  return (
    <>

      <Grid container>
        <Grid sx={style.mainBox}>        
          <Box>
            <Typography variant="body1" sx={style.mainHeading}>
            Payroll Salary Slip
            </Typography>    
          </Box>
          <Box sx={{display: "flex"}}>
            <Button variant="contained" sx={style.printbtn}>
              <Box sx={style.downloadIcon}>  <Print /> </Box>
               Print
            </Button>

            <Button variant="contained" sx={style.exportbtn} onClick={handleDownloadPDF}>
              <Box sx={style.downloadIcon}>  <Download /> </Box>
               Export PDF
            </Button>
            <Button variant="contained" sx={style.downloadbtn}>
              <Box sx={style.downloadIcon}>  <Send /> </Box>
               Send Invoice
            </Button>




          </Box>
        </Grid>

        <Grid container sx={style.whiteSection}>
          <Grid item sx={style.gridBox}>
            <Box>
              <Typography sx={style.payslipHeading}>Payslip #4950</Typography>
              <Typography sx={style.payslipDate}>SalarySlip 29 March 2024</Typography>
            </Box>
            <Box sx={style.line}></Box>

            <Box sx={style.profileGrid}>
              <Box sx={{my: 1}}>
                <Typography sx={style.introText}>From:</Typography>
                <Avatar src={Profile} sx={style.profileAvtar} />
                <Typography sx={style.pixelText}>PixelWibes</Typography>
                <Typography sx={style.introText}>111  Berkeley Rd</Typography>
                <Typography sx={style.introText}>STREET ON THE FOSSE, Poland</Typography>
                <Typography sx={style.introText}>Email: info@deoweb.com</Typography>
                <Typography sx={style.introText}>Phone: +44 888 666 3333</Typography>


              </Box>

              <Box sx={{my: 1}}>
                <Typography sx={style.introText}>To:</Typography>
                <Typography sx={style.pixelTextTo}>John</Typography>
                <Typography sx={style.introText}>Web Designer</Typography>
                <Typography sx={style.introText}>Employee ID: 49494730</Typography>
                <Typography sx={style.introText}>Joining Date: 10 May 2020</Typography>

              </Box>
            </Box>
            <Grid container sx={style.earningGrid}>
              <Grid item xs={12} lg={5} >
                <Typography sx={style.earningHeading}>Earnings</Typography>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Basic Salary
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $6500
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>House Rent Allowance (H.R.A.)
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $60
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Conveyance
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $33
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Other Allowance
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $21
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Total Earnings
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $6614
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                

              </Grid>
              <Grid item xs={12} lg={5} >
                <Typography sx={style.earningHeading}>Deduction</Typography>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Tax Deducted at Source (T.D.S.)
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $0
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Unpaid Leave
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $0
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>ESI
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $1
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Loan
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $100
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                <Box sx={style.earningInfo}>
                  <Box sx={style.infoTextsec}>
        
                    <Typography sx={style.infoText}>Total Deductions
                    </Typography>
                  </Box>
                  <Box sx={style.infoValueSec}>
                    <Typography sx={style.infoValue}>
                      $101
                    </Typography>
                  </Box>

                </Box>
                <Box sx={style.lines}></Box>
                
                <Box sx={style.lastBox}>
                  <Typography sx={style.infoValue}>Total Earnings: $6614</Typography>
                  <Typography sx={style.infoValue}>Total Deductions: $101</Typography>
                  <Typography sx={style.netSalary}>Net Salary $6513.00</Typography>


                </Box>

                

                


              </Grid>

            </Grid>
          </Grid>


        </Grid>


      </Grid >


    </>
  )
}
export default PayrollSalaryPage;
